import { QrCode } from "lucide-react";

import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

/**
 * Confirmação antes de gerar o QR do PIX Online (Mesas).
 *
 * Pedido do dono: clicar em PIX ONLINE não pode disparar a cobrança direto —
 * primeiro pergunta se pode gerar o QR; só no "Gerar QR Code" a cobrança é
 * criada no Mercado Pago e o QR aparece na tela pro cliente escanear.
 */
export default function PixGerarQrModal({ open, onOpenChange, total, onGerar }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[95vw] max-w-[95vw] sm:max-w-sm rounded-xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-teal-500 text-white flex items-center justify-center">
              <QrCode className="w-4 h-4" />
            </span>
            PIX Online
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-1">
          <div className="rounded-xl bg-teal-500/10 border border-teal-500/30 px-4 py-3 text-center">
            <p className="text-xs text-muted-foreground">Valor da cobrança</p>
            <p className="text-2xl font-black text-teal-600 dark:text-teal-400 tabular-nums">
              R$ {(Number(total) || 0).toFixed(2).replace(".", ",")}
            </p>
          </div>

          <p className="text-sm text-center text-muted-foreground">
            Gerar o QR Code para o cliente escanear e pagar agora?
          </p>

          <div className="grid grid-cols-2 gap-2">
            <Button variant="outline" className="h-11" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button
              className="h-11 font-bold bg-teal-600 hover:bg-teal-700 text-white"
              onClick={() => { onOpenChange(false); onGerar(); }}
            >
              <QrCode className="w-4 h-4 mr-1.5" /> Gerar QR Code
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
